import React from 'react';
import { findCompByIdRecursively, recalculateIndexes } from '../../utils/functions';
import { placeholder64 } from '../../utils/layoutConfig';
import { toPng } from 'html-to-image';
import { useDispatch, useSelector } from 'react-redux';
import defaultPages from '../../utils/defaultPages';
import { allPages, updatePages, selectedPageObject } from '../../redux/pagesSlice';
import { selectedPage, selectPage } from '../../redux/selectedPageSlice';
import CanvasElements from './CanvasElements';
import queries from '../../utils/query';
import { useQuery, useMutation } from '@apollo/client';
import { DragDropContext } from 'react-beautiful-dnd';
import LeftMenu from './LeftMenu';
import DefaultProps from '../../utils/defaultProps';
import { Box, useToast } from '@chakra-ui/react';
import { visualizationMode } from '../../redux/visualizationModeSlice';
import { IntlProvider } from 'react-intl';
import { selectedToggleValue } from '../../redux/canvasResolutionSlice';

/**
 * Atualmente feito apenas como linhas, mas eventualmente cada linha poderá ter mais de 1 componente,
 * por isso o array de components dentro do objeto da linha
 */

let viewPreviewLastUpdate = null;
const jsonDiff = require('jsondiffpatch').create();

function generateViewPreview({ imgRef }) {
	return new Promise((resolve, reject) => {
		if (!imgRef || !imgRef.current) {
			resolve(placeholder64);
		}
		const w = imgRef.current.offsetWidth;
		const h = imgRef.current.offsetHeight;
		const ratio = Math.round(w / 250);
		const newW = w / ratio;
		const newH = h / ratio;
		const opts = { canvasWidth: newW };

		if (newH < 500) {
			opts.canvasHeight = newH;
		} else {
			opts.heigth = 500;
		}

		toPng(imgRef.current, opts)
			.then((png) => {
				if (png === 'data:,') {
					resolve(placeholder64);
				} else {
					resolve(png);
				}
			})
			.catch((e) => {
				resolve(placeholder64);
			});
	});
}

function generatePlaceholderProps({ e }) {
	const draggedDOM = getDraggedDom(e);
	if (!draggedDOM) {
		return null;
	}

	if (!e.destination) return null;

	let placeholderProps = {};
	let DOMSpread = [];
	let updatedArray = [];
	const destinationIndex = e.destination.index;
	const sourceIndex = e.source.index;
	const { clientHeight, clientWidth } = draggedDOM;

	if (e.source.droppableId.includes('AvailableComponents')) {
		DOMSpread = [...document.getElementsByClassName('placeholder-container')[0].children];
		updatedArray = getUpdatedArray({ movedItem: draggedDOM, DOMSpread, destinationIndex });
		placeholderProps = {
			clientHeight: 113,
			clientWidth: '100%',
			clientX: 0,
		};
	} else {
		const movedItem = DOMSpread[sourceIndex];
		DOMSpread = [...draggedDOM.parentElement.children];
		updatedArray = getUpdatedArray({ movedItem, sourceIndex, DOMSpread, destinationIndex });
		placeholderProps = {
			clientHeight,
			clientWidth,
			clientX: parseFloat(window.getComputedStyle(draggedDOM.parentNode).paddingLeft),
		};
	}

	const clientY =
		parseFloat(window.getComputedStyle(draggedDOM).paddingTop) +
		updatedArray.slice(0, destinationIndex).reduce((total, curr) => {
			const style = curr.currentStyle || window.getComputedStyle(curr);
			const marginBottom = parseFloat(style.marginBottom);
			const marginTop = parseFloat(style.marginTop);
			return total + curr.clientHeight + marginBottom + marginTop;
		}, 0);

	placeholderProps.clientY = clientY;

	return placeholderProps;
}

function getUpdatedArray({ movedItem, sourceIndex, DOMSpread, destinationIndex }) {
	if (sourceIndex || sourceIndex == 0) {
		DOMSpread.splice(sourceIndex, 1);
	}
	return [...DOMSpread.slice(0, destinationIndex), movedItem, ...DOMSpread.slice(destinationIndex + 1)];
}

function getDraggedDom({ draggableId, source }) {
	const domQuery = `[data-rbd-drag-handle-draggable-id='${draggableId}']`;
	const draggedDOM = source.droppableId.includes('AvailableComponents')
		? document.querySelector(domQuery).parentNode
		: document.querySelector(domQuery).previousElementSibling.parentNode;

	return draggedDOM;
}

function setTemplates(pages, templateId) {
	pages.forEach(({ pageData }, index) => {
		pageData.forEach((_, pageDataIndex) => {
			if (!pages[index].pageData[pageDataIndex].templateId)
				pages[index].pageData[pageDataIndex].templateId = templateId;
		});
	});
}
const DragDropContextContainer = ({
	viewId,
	userInfo,
	setRecentCommitsIsOpen,
	leftDrawerIsOpen,
	setLeftDrawerIsOpen,
	isDebugActive,
	recentCommitsIsOpen,
}) => {
	const dispatch = useDispatch();
	const pages = useSelector(allPages);
	const VMMode = useSelector(visualizationMode);
	const selectedPageValue = useSelector(selectedPage);
	const templateId = 1;
	const defaultPagesObject = defaultPages(templateId);
	const toast = useToast();
	//componentes
	const [componentList, setComponentList] = React.useState([]); //lista de componentes disponíveis
	const [filteredComponentList, setFilteredComponentList] = React.useState([]); //Para o resultado de busca
	// const [components, setComponents] = React.useState(false) //componentes selecionados
	const [tabIndex, setTabIndex] = React.useState(-1); //components tabindex

	//Database - pegando projeto e atualizando projeto
	const { loading, error, data } = useQuery(queries.GET_VIEW(viewId));
	const [updateViewListPreview] = useMutation(queries.UPDATE_VIEW_PREVIEW);

	const [lastPages, setLastPages] = React.useState([]);
	const [dummyPages, setDummyPages] = React.useState([]); //dummy pages para simular o que foi alterado no commit -- fazer para que alteração afete apenas a pág, não o todo

	//ref da box que será usada para gerar a imagem de thumb do projeto
	const imgRef = React.useRef(null);
	//criando nova alteração
	const [createCommit] = useMutation(queries.CREATE_COMMIT);

	//placeholder
	const [placeholderProps, setPlaceholderProps] = React.useState({});

	//redux canvasResolution
	const canvasResolution = useSelector(selectedToggleValue);

	//page from queryString
	React.useEffect(() => {
		const page = window.location.hash;
		if (pages && page && page != selectedPageValue) {
			let newPage = page.replace('#', '');
			if (!newPage) newPage = 'default-1';
			dispatch(selectPage(newPage));
		}
	}, [window.location.hash, pages]);

	//No retorno do apollo, preenchendo o pages
	React.useEffect(() => {
		if (data && data.view && data.view.jsonContent) {
			if (data.view.jsonContent != '[]') {
				const contentString = data.view.jsonContent;
				try {
					// setPages(JSON.parse(contentString))
					const pages = JSON.parse(contentString);
					//fix, remover no futuro
					// setTemplates(pages, templateId);
					dispatch(updatePages(pages));

					setLastPages(JSON.parse(contentString));
				} catch (e) {
					console.error(e); //Caso não seja uma string json
				}
			} else {
				// setTemplates(newDefaultPages, templateId);
				dispatch(updatePages(defaultPagesObject));
				// setPages(defaultPages)
			}
		}
	}, [data]);

	React.useEffect(() => {
		if (error) {
			toast({
				title: 'Erro ao obter projeto',
				description: 'Ocorreu um erro ao tentar obter o projeto do banco de dados',
				status: 'error',
				duration: 5000,
				isClosable: true,
			});
		}
	}, [error]);
	//Atualizando bd quando há mudança de estado nas páginas
	React.useEffect(() => {
		window.pages = pages;
		let timeout;
		const pageString = pages ? JSON.stringify(pages) : '{}';
		const lastPageString = lastPages ? JSON.stringify(lastPages) : '{}';

		if (checkIfPagesAreEmpty(pages)) return;

		if (data && !loading && lastPageString !== pageString) {
			const delta = jsonDiff.diff(lastPages, pages);
			if (delta && delta !== 'no diff') {
				const userData = userInfo;
				createCommit({
					variables: {
						viewId: String(viewId),
						commitValue: JSON.stringify(delta),
						userId: userData.id,
						userEmail: userData.name,
						userName: userData.email,
					},
				});

				const dateNow = new Date();

				if (!viewPreviewLastUpdate || Math.abs(viewPreviewLastUpdate.getTime() - dateNow.getTime()) > 1000 * 10) {
					timeout = setTimeout(() => {
						generateViewPreview({ imgRef }).then((img) => {
							viewPreviewLastUpdate = dateNow;
							updateViewListPreview({
								variables: {
									viewId: String(viewId),
									viewPreview: img,
								},
							});
						});
					}, 3000);
				}

				setLastPages(JSON.parse(pageString));
			}
		}

		return () => {
			clearTimeout(timeout);
		};
	}, [pages]);

	//function checkIfPagesAreEmpty to check if pages pageData are empty
	//if they are, return true

	function checkIfPagesAreEmpty(pages) {
		let empty = true;
		pages.forEach((page) => {
			if (page.pageData.length > 0) {
				empty = false;
			}
		});
		return empty;
	}

	function onDragEnd(result) {
		const { destination, source, draggableId } = result;
		if (!destination || (destination.droppableId === source.droppableId && destination.index === source.index)) {
			return;
		}
		if (destination.droppableId) {
			moveElement({ destination, source, draggableId });
		}
	}

	function moveElement({ destination, source, draggableId }) {
		const newPages = JSON.parse(JSON.stringify(pages));
		const newSelectedPage = newPages.find((el, index) => {
			return el.pageId == selectedPageValue;
		});
		const destId = destination.droppableId.replace('-droppable', '');
		const { comp } = findCompByIdRecursively(newSelectedPage.pageData, destId);

		if (source.droppableId.includes('AvailableComponents')) {
			if (destination.droppableId == 'CANVAS') {
				const props = DefaultProps[draggableId];
				const newElement = typeof props === 'function' ? props() : props;
				// newElement.componentId = uuidv4()
				newElement.templateId = 1;

				//if pageType is search, add new element to newSelectedPage.pageData with prop moveTo as desktop or mobile
				// let parentIndex = 0
				if (newSelectedPage.pageType == 'search') {
					if (selectedToggleValue > 1024) {
						newElement.moveTo = 'desktop';
					} else {
						newElement.moveTo = 'mobile';
					}
				}
				// if (newSelectedPage.pageType === "search") {
				//     if (canvasResolution > 1024) {
				//         newElement.moveTo = "desktop";
				//         parentIndex = newSelectedPage.pageData.findIndex((el)=>el.componentGroup == "SearchResultLayoutDesktop")
				//     } else {
				//         newElement.moveTo = "mobile";
				//         parentIndex = newSelectedPage.pageData.findIndex((el)=>el.componentGroup == "SearchResultLayoutMobile")
				//     }

				//     let nOfElementsBefore = 0
				//     newSelectedPage.pageData.forEach((el,index)=>{
				//         if(index>=destination.index) return
				//         if(el.moveTo == newElement.moveTo || el?.componentGroup.includes(newElement.moveTo)) nOfElementsBefore++
				//     })

				//     if(parentIndex>=destination.index){
				//         newElement.moveIndex = nOfElementsBefore
				//     }else{
				//         newElement.moveIndex = nOfElementsBefore + newSelectedPage.pageData[parentIndex].childrenComponents.length
				//     }

				//     newSelectedPage.pageData.forEach((el)=>{
				//         if(el.moveTo == newElement.moveTo && el.moveIndex >= newElement.moveIndex){
				//             el.moveIndex++
				//         }
				//     })

				// }
				newSelectedPage.pageData.push({
					...newElement,
				});
				const len = newSelectedPage.pageData.length;
				newSelectedPage.pageData.swap(len - 1, destination.index);
				recalculateIndexes(newSelectedPage);
			}
		} else {
			//just moving inside the canvas
			if (destination.droppableId == source.droppableId) {
				if (destId == 'CANVAS') {
					//finding component beign moved by getting element from pageData using soruce index
					//and adding prop moveIndex to it as destination index
					const sourceComp = newSelectedPage.pageData[source.index];
					//destination comp
					const destComp = newSelectedPage.pageData[destination.index];

					newSelectedPage.pageData.swap(source.index, destination.index);
					sourceComp.moveIndex = getVisibleComponents({ pageData: newSelectedPage.pageData }).findIndex(
						(compId) => compId == sourceComp.componentId,
					);
					//adding moveIndex to both components because we dont know which one is the one we need to add the moveIndex prop
					destComp.moveIndex = getVisibleComponents({ pageData: newSelectedPage.pageData }).findIndex(
						(compId) => compId == destComp.componentId,
					);
				} else {
					//finding component beign moved by getting element from pageData using soruce index
					//and adding prop moveIndex to it as destination index
					const sourceComp = comp.childrenComponents[source.index];
					comp.childrenComponents.swap(source.index, destination.index);
					sourceComp.moveIndex = destination.index;
				}
			} else {
				//atualmente nao usado
				//não é a msm source, mudando componente de array
				const sourceResult = findCompByIdRecursively(newSelectedPage.pageData, draggableId);
				const sourceIndex = sourceResult.index;
				const sourceArr = sourceResult.parentArray;
				const sourceComp = sourceResult.comp;
				//removendo do original source p não duplicar
				sourceArr.splice(sourceIndex, 1);
				//ignorando por hora os indexes
				if (comp.childrenComponents) {
					comp.childrenComponents.push(sourceComp);
				} else {
					comp.childrenComponents = [sourceComp];
				}
			}
		}
		dispatch(updatePages(newPages));
		// setPages(newPages)
	}

	//function to return a new array of things visible on screen
	//if component is not visible, it should not be counted
	//to check if the component is visible we check if the componentGroup contains the word mobile or desktop
	//then compare it with the current canvasResolution to check if it is visible or not
	//if the component has a prop called moveTo and it is equal to the visibility state, it should be counted
	//counted means pushing the component.componentId into the array

	function getVisibleComponents({ pageData }) {
		const visibleComponents = [];
		const visibilityState = canvasResolution > 1024 ? 'desktop' : 'mobile';
		pageData.forEach((component) => {
			if (component.componentGroup.toLowerCase().includes(visibilityState)) {
				visibleComponents.push(component.componentId);
			} else if (component.moveTo === visibilityState) {
				visibleComponents.push(component.componentId);
			}
		});
		return visibleComponents;
	}

	function onDragStart(e) {
		const placeholderProps = generatePlaceholderProps({ e });
		if (placeholderProps) setPlaceholderProps(placeholderProps);
	}

	function onDragUpdate(e) {
		if (!e.destination) {
			return;
		}

		const placeholderProps = generatePlaceholderProps({ e });
		if (placeholderProps) setPlaceholderProps(placeholderProps);
	}
	return (
		<DragDropContext onDragEnd={onDragEnd} onDragStart={onDragStart} onDragUpdate={onDragUpdate}>
			<LeftMenu
				{...{
					viewId,
					setRecentCommitsIsOpen,
					tabIndex,
					setTabIndex,
					leftDrawerIsOpen,
					setLeftDrawerIsOpen,
					setComponentList,
					filteredComponentList,
					componentList,
				}}
			/>
			<Box d={'flex'} w={'100%'} flexBasis={'auto'} margin={!VMMode ? '72px 0px 0 0px' : 0}>
				<Box d={'flex'} w={'100%'} flexDir={'column'} h={'100%'} flex={1}>
					<IntlProvider locale="br" defaultLocale="br">
						<CanvasElements
							{...{ dummyPages, recentCommitsIsOpen, imgRef, loading, placeholderProps, isDebugActive }}
						/>
					</IntlProvider>
				</Box>
			</Box>
		</DragDropContext>
	);
};

export default DragDropContextContainer;
